export enum IntegrationServices {
  HUBSPOT = 'hubspot',
  ZAPIER = 'zapier',
  SALESFORCE = 'salesforce',
  MS_DYNAMICS_SALES = 'ms_dynamics_sales',
}
